import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InputSharedComponent } from './input.component';
import { FaIconSharedModule } from './../../atoms/fa.icon/fa.icon.module';

@NgModule({
    declarations: [
        InputSharedComponent
    ],
    imports: [
        CommonModule,
        FaIconSharedModule
    ],
    exports: [
        InputSharedComponent
    ]
})

export class InputSharedModule {}
